/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";

const provinceOptions = [
  { value: "Cần Thơ", label: "Cần Thơ" },
  { value: "Cần Thơ 2", label: "Cần Thơ 2" },
  { value: "Cần Thơ 3", label: "Cần Thơ 3" },
  { value: "Cần Thơ 4", label: "Cần Thơ 4" },
];
const typeRefundOptions = [
  { value: "Chuyển khoản", label: "Chuyển khoản" },
  { value: "Tiền mặt", label: "Tiền mặt" },
];

export default function Fields2({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    moneyRefund,
    ownerBankName,
    accountNumber,
    bankName,
    receiverName,
    receiverNameId,
    date,
    place,
    inventory,
    typeRefund,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box my={2}>
        <Typography variant="subtitle1">
          Trường hợp người nộp thuế đề nghị hoàn trả vào tài khoản của người nộp thuế tại chỉ tiêu
          [46] thì ghi thêm các thông tin sau:
        </Typography>
      </Box>
      <Grid spacing={3} container>
        <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
          <FormField
            type={moneyRefund.type}
            label={moneyRefund.label}
            name={moneyRefund.name}
            value={values.moneyRefund}
            placeholder={moneyRefund.placeholder}
            error={errors.moneyRefund && touched.moneyRefund}
            success={values.moneyRefund.length > 0 && !errors.moneyRefund}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}></Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SelectField
            options={typeRefundOptions}
            type={typeRefund.type}
            label={typeRefund.label}
            name={typeRefund.name}
            value={values.typeRefund}
            placeholder={typeRefund.placeholder}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}></Grid>
        {values.typeRefund === "Chuyển khoản" && (
          <>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <FormField
                type={ownerBankName.type}
                label={ownerBankName.label}
                name={ownerBankName.name}
                value={values.ownerBankName}
                placeholder={ownerBankName.placeholder}
                error={errors.ownerBankName && touched.ownerBankName}
                success={values.ownerBankName.length > 0 && !errors.ownerBankName}
              />
            </Grid>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <FormField
                type={accountNumber.type}
                label={accountNumber.label}
                name={accountNumber.name}
                value={values.accountNumber}
                placeholder={accountNumber.placeholder}
                error={errors.accountNumber && touched.accountNumber}
                success={values.accountNumber.length > 0 && !errors.accountNumber}
              />
            </Grid>
            <Grid item xs={12} style={{ paddingTop: 0 }}>
              <FormField
                type={bankName.type}
                label={bankName.label}
                name={bankName.name}
                value={values.bankName}
                placeholder={bankName.placeholder}
                error={errors.bankName && touched.bankName}
                success={values.bankName.length > 0 && !errors.bankName}
              />
            </Grid>
          </>
        )}
        {values.typeRefund === "Tiền mặt" && (
          <>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <FormField
                type={receiverName.type}
                label={receiverName.label}
                name={receiverName.name}
                value={values.receiverName}
                placeholder={receiverName.placeholder}
                error={errors.receiverName && touched.receiverName}
                success={values.receiverName.length > 0 && !errors.receiverName}
              />
            </Grid>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <FormField
                type={receiverNameId.type}
                label={receiverNameId.label}
                name={receiverNameId.name}
                value={values.receiverNameId}
                placeholder={receiverNameId.placeholder}
                error={errors.receiverNameId && touched.receiverNameId}
                success={values.receiverNameId.length > 0 && !errors.receiverNameId}
              />
            </Grid>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <DatepickerField
                name={date.name}
                label={date.label}
                error={errors.date && touched.date}
                success={values.date?.toString().length > 0 && !errors.date}
              />
            </Grid>
            <Grid item xs={12} lg={6} style={{ paddingTop: 0 }}>
              <FormField
                type={place.type}
                label={place.label}
                name={place.name}
                value={values.place}
                placeholder={place.placeholder}
                error={errors.place && touched.place}
                success={values.place.length > 0 && !errors.place}
              />
            </Grid>
            <Grid item xs={12} style={{ paddingTop: 0 }}>
              <FormField
                type={inventory.type}
                label={inventory.label}
                name={inventory.name}
                value={values.inventory}
                placeholder={inventory.placeholder}
                error={errors.inventory && touched.inventory}
                success={values.inventory.length > 0 && !errors.inventory}
              />
            </Grid>
          </>
        )}
      </Grid>
      <Box my={2}>
        <Typography variant="subtitle1">
          Trường hợp người nộp thuế đề nghị bù trừ cho khoản nộp ngân sách nhà nước khác tại chỉ
          tiêu [47] thì ghi thêm các thông tin sau:
        </Typography>
        <Typography variant="subtitle1">
          Khoản nợ, Khoản thu phát sinh đề nghị được bù trừ
        </Typography>
      </Box>
    </Box>
  );
}
